import React from 'react';
import './Card.css';

const Card = ({ 
  children, 
  className = '', 
  padding = '20px 16px 28px',
  maxWidth = '520px',
  centered = true,
  ...props 
}) => {
  const cardClasses = `card ${centered ? 'card--centered' : ''} ${className}`.trim();
  
  return (
    <div 
      className={cardClasses}
      style={{ 
        '--card-padding': padding,
        '--card-max-width': maxWidth,
        ...props.style 
      }}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card; 